"use strict";
var Observable_1 = require('../../Observable');
var audit_1 = require('../../operator/audit');
Observable_1.Observable.prototype.audit = audit_1.audit;
//# sourceMappingURL=audit.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3659550778/src/~/rxjs/add/operator/audit.js
// module id = pkLr
// module chunks = 6